<template>
  <b-container fluid>
    <Workschedule :idProfessional="idProfessional"></Workschedule>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";

import Workschedule from "../../../components/workschedule/Workschedule";

import utilsService from "../../../services/utils";

export default {
  name: "WorkscheduleProfessional",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
  },
  computed: {},
  methods: {},
  data() {
    return {
      idProfessional: localStorage.getItem("userId"),
    };
  },
  components: {
    Workschedule,
  },
};
</script>